import * as z from "zod";

export enum SendEmailAuthLinkError {
  InvalidEmail = "InvalidEmail",
  UnknownError = "UnknownError",
}

const sendEmailAuthLinkPurposeSchema = z.enum(["login", "registration"]);
export type SendEmailAuthLinkPurpose = z.infer<
  typeof sendEmailAuthLinkPurposeSchema
>;

export const sendEmailAuthLink = {
  name: "sendEmailAuthLink" as const,
  input: z.object({
    email: z.string(),
    baseUrl: z.string(),
    nextUrl: z.string().optional(),
    purpose: sendEmailAuthLinkPurposeSchema.optional(),
  }),
  output: z.object({}),
};
